import React from "react";
import "./index.css";
import { AnalyticsProvider } from "./src/components/Analytics/AnalyticsProvider";
import { trackPageView, initAnalytics } from "./src/services/analyticsService";

export const onClientEntry = () => {
  initAnalytics();
};

// Logs when the client route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
  // console.log("new pathname", location.pathname);
  // console.log("old pathname", prevLocation ? prevLocation.pathname : null);
  trackPageView(location.pathname);
};

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <AnalyticsProvider>{element}</AnalyticsProvider>;
};
